import { useNavigate, useParams } from "react-router-dom";
import { InputField, SelectField } from "../../../form/input-fields";
import ModalPageFooter from "../../../global-layout/modal-page-footer";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, useFieldArray } from "react-hook-form";
import { useEffect, useMemo, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Skeleton from "react-loading-skeleton";
import { masterAccess } from "../../../../services/InspectionOneServices";
import MasterDetails from "../../../../pages/master-details/master-details";
import UploadImage from "../../../form/upload-image";
import {
  MultiSelectInput,
  SelectInput,
  SelectInputWithoutForm,
} from "../../../form/select-input";
import UploadExcelFile from "../../../form/UploadFile";
import ToastifyMessage from "../../../../lib/toastify";
import { ToastError, ToastSuccess, ToastWarning } from "../../../UI/toast";
import IconBtn from "../../../form/icon-btn";
import { DeleteIcon } from "../../../svg";
import SegmentFields from "../custom-master-form";
import { MACHINE_TYPE_OPTIONS } from "../../../../utils/constants";

function CreateUserMasterForm({
  headerDetails,
  accessQueryDetails,
  userMasterUpdated,
  dependentData,
}: any) {
  const { tableId, id } = useParams();
  const [initialData, setInitialData] = useState<any>([]);
  const [fieldData, setFieldData] = useState<any>([]);
  const [inputContainerWidth, setInputContainerWidth] = useState<any>(80);
  const [dynamicShape, setDynamicShape] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [masterType, setMasterType] = useState(0);
  const [masterSubType, setMasterSubType] = useState(0);
  useEffect(() => {
    if (initialData && headerDetails) {
      if (initialData.length == 0 || headerDetails.length == 0) {
        return;
      }
      const titles = initialData.map((item: any) => {
        const keys = Object.keys(item);
        const values = Object.values(item);
        const headerDetailsList = headerDetails;
        //skip id from keys for dynamic
        const labelValuePairs = keys.map((key, i) => ({
          label: key,
          value: values[i],
          isMandatory:
            headerDetailsList[i - 1] !== undefined
              ? headerDetailsList[i - 1].isMandatory
              : 0,
          type:
            headerDetailsList[i - 1] !== undefined
              ? headerDetailsList[i - 1].type
              : 0,
          headerName:
            headerDetailsList[i - 1] !== undefined
              ? headerDetailsList[i - 1].headerName
              : "",
          isColumnHide:
            headerDetailsList[i - 1] !== undefined
              ? headerDetailsList[i - 1].isColumnHide
              : "",
          isEditRestrictable:
            headerDetailsList[i - 1] !== undefined
              ? headerDetailsList[i - 1].isEditRestrictable
              : "",
          additionalDetails:
            headerDetailsList[i - 1] !== undefined
              ? headerDetailsList[i - 1].additionalDetails
              : "",
        }));
        return labelValuePairs;
      });
      if (titles[0]) {
        setFieldData(titles[0]);
        const shape = titles[0].reduce((acc: any, item: any) => {
          if (item.type === 4 || item.type === 2) {
            item.value = getDependentOptions(
              item.headerName,
              item.value,
              dependentData,
              item.type
            );
          }
          if (item.isMandatory) {
            acc[item.label] =
              item.type === 2
                ? yup
                  .mixed()
                  .nullable()
                  .test(
                    "not-empty-object",
                    `${item.headerName} is required`,
                    (value) => value !== null && value !== undefined && Object.keys(value).length > 0
                  )
                : item.type === 4
                  ? yup.array().min(1, `${item.headerName} is required`)
                  // : item.type === 6
                  // ? yup
                  //     .string()
                  //     .test(
                  //       "is-required",
                  //       `${item.headerName} is required`,
                  //       () => !!formData.imageUrl?.trim() // Check if formData.imageUrl exists and is not empty
                  //     )
                  : yup.string().required(`${item.headerName} is required`);
          }
          // else {
          //   acc[item.label] =
          //     item.type === 2
          //       ? yup.object()
          //       : item.type === 4
          //       ? yup.array()
          //       : yup.string();
          // }
          return acc;
        }, {});
        setDynamicShape(shape);
      }

    }
    if(accessQueryDetails){
      setMasterType(accessQueryDetails.type)
      setMasterSubType(accessQueryDetails.subType);
    }
  }, [initialData, headerDetails, accessQueryDetails]);

  const { ToastifyHandle } = ToastifyMessage();

  const handleSuccess = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastSuccess title={titleName} description={message} />,
      "success"
    );
  };
  const handleError = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastError title={titleName} description={message} />,
      "error"
    );
  };
  const handleWarning = (titleName: any, message: any) => {
    ToastifyHandle(
      <ToastWarning title={titleName} description={message} />,
      "warning"
    );
  };

  function getDependentOptions(
    label: string,
    value: any,
    dependentData: any,
    type: any
  ) {
    const dependentObject = dependentData.find(
      (item: any) => item.uniqueId === label
    );
    const data = dependentObject ? dependentObject.dependentValues : [];
    const finalData = (data || []).map((value: any) => ({
      id: value.id,
      value: value.value,
      label: value.value,
    }));
    const valueArray =
      typeof value === "string" && value.trim() !== "" ? value.split(",") : [];
    if (type === 2) {
      const matchedObject = finalData.find(
        (item: any) => item.id === parseInt(valueArray[0], 10)
      );
      return matchedObject || {};
    } else if (type === 4) {
      const filteredArray = finalData.filter((item: any) =>
        valueArray.includes(String(item.id))
      );
      return filteredArray.length > 0 ? filteredArray : [];
    }
    return [];
  }

  useEffect(() => {
    if(!headerDetails){
      navigate("/master-details/user-master/" + tableId );
      return;
    }
    if (id !== "new") {
      handleMasterEdit(id);
    } else {
      const initialObject = headerDetails.reduce((acc: any, column: any) => {
        acc[column.field] = "";
        return acc;
      }, {});
      setInitialData([{ id: 0, ...initialObject }]);
    }
  }, [id]);

  const [dependentOptions, setDependentOptions] = useState<
    Record<string, any[]>
  >({});

  useEffect(() => {
    if(!headerDetails){
      navigate("/master-details/user-master/" + tableId );
      return;
    }
    const optionsMap: Record<string, { value: string; label: string }[]> =
      dependentData.reduce(
        (
          acc: Record<string, { value: string; label: string }[]>,
          item: any
        ) => {
          acc[item.uniqueId] = (item.dependentValues || []).map(
            (value: any) => ({
              id: value.id,
              value: value.value,
              label: value.value,
            })
          );
          return acc;
        },
        {}
      );
    setDependentOptions(optionsMap);
  }, [dependentData]);

  const [isImageLoader, setImageLoader] = useState(false);
  const [formData, setFormData] = useState({ imageUrl: "" });

  const createFormSchema = useMemo(() => yup.object().shape(dynamicShape), [dynamicShape]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    getValues,
    watch,
  } = useForm({
    resolver: yupResolver(createFormSchema),
  });

  const generateGuid = () => {
    return uuidv4();
  };

  const navigate = useNavigate();

  const handleFormSubmit = async (data: any) => {
    try {
      setIsLoading(true);
      data.id = id !== "new" && id ? id : 0;
      const subMode = id !== "new" ? 2 : 1;
      let newData = { ...data };
      if (masterType == 1 && masterSubType == 3) {
        const segmentDetailsHeader = headerDetails.find(
          (item: any) => item.headerName === "Segment Details"
        );
        const parsedSegmentDetails = JSON.parse(segmentDetailsHeader.additionalDetails).segmentDetails;
        const parsedMachineDetails = JSON.parse(segmentDetailsHeader.additionalDetails).machineDetails;

        const updatedSegmentDetails = newData.segmentDetails.map((segment: any) => {
          const normalizedSegment = { ...segment };

          // Normalize segment-level fields
          Object.keys(parsedSegmentDetails).forEach((key) => {
            if (normalizedSegment[key] === "") {
              normalizedSegment[key] = parsedSegmentDetails[key];
            }
          });

          // Normalize machine-level fields inside each segment
          const updatedMachineDetails = segment.machineDetails.map((machine: any) => {
            const normalizedMachine = { ...machine };

            Object.keys(parsedMachineDetails).forEach((key) => {
              if (normalizedMachine[key] === "") {
                normalizedMachine[key] = parsedMachineDetails[key];
              }
            });

            // Normalize machineType specifically
            normalizedMachine.machineType = normalizedMachine.machineType?.value ?? normalizedMachine.machineType;

            return normalizedMachine;
          });

          return {
            ...normalizedSegment,
            machineDetails: updatedMachineDetails
          };
        });

        newData = {
          id: data.id,
          value: newData.value,
          segmentDetails: updatedSegmentDetails
        };
      }
      else {
        newData = Object.keys(newData).reduce((acc: any, key: string) => {
          if (Array.isArray(newData[key])) {
            acc[key] = newData[key].map((item: any) => item.id).join(",");
          } else if (typeof newData[key] === "object" && newData[key] !== null) {
            acc[key] = newData[key].id ? newData[key].id : newData[key];
          } else {
            acc[key] = newData[key];
          }
          return acc;
        }, {});
      }

      createFormSchema.validate(data);
      const requestJson = {
        headerDetails: headerDetails,
        accessUniqueId: masterId.trim(),
        masterValueId: id,
        actionMode: 1,
        actionSubMode: subMode,
        masterType: masterType,
        masterSubType: masterSubType,
        masterDetails: [newData],
      };
      const response = await masterAccess.MasterDetailsAction(requestJson);
      if (response.success) {
        setIsLoading(false);
        //setInitialData(response.data.masterValueDetails);
        userMasterUpdated(true);
        navigate(-1);
      } else {
        handleError("Duplicate Data", response.message);
        setIsLoading(false);
        navigate(-1);
      }
    } catch (error) {
      setIsLoading(false);
      navigate(-1);
    }
  };

  const handleFormCancel = () => {
    navigate(-1);
  };

  const currentUrl: string = window.location.href;
  const parts = currentUrl.split("/");
  const masterId = parts[parts.length - 3];

  const handleMasterEdit = async (uniqueId: any) => {
    try {
      setIsLoading(true);
      const requestJson = {
        masterAccessId: masterId.trim(),
        masterValueId: uniqueId.trim(),
      };
      const response = await masterAccess.MasterDetailsActionFetch(requestJson);
      if (response.success) {
        setIsLoading(false);
        setInitialData(response.data.masterValueDetails);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleSetFormData = (imageUrl: any, extraFormData: any) => {
    let copyFormData: any = { ...formData };

    copyFormData.imageUrl = imageUrl;


    setFormData(copyFormData);


    if (extraFormData) {
      const updatedData = fieldData.map((item: any) => ({ ...item, value: extraFormData[item.label] }));

      setFieldData(updatedData);
    }



  }


  useEffect(() => {
    const valuesToSet: any = {};
    fieldData.forEach((field: any) => {
      if (field.value !== undefined) {
        if (field.type === 7) {
          setInputContainerWidth(100);
          try {
            const segmentDetails = JSON.parse(field.value);

            const updatedSegmentDetails = segmentDetails.map((segment: any) => {
              const updatedMachines = (segment.machineDetails || []).map((machine: any) => {
                const machineTypeValue = machine.machineType;

                // Map string/number value to full object {value, label}
                const matchedOption = MACHINE_TYPE_OPTIONS.find(
                  (opt) => opt.value === String(machineTypeValue)
                );

                return {
                  ...machine,
                  machineType: matchedOption || machineTypeValue,
                };
              });

              return {
                ...segment,
                machineDetails: updatedMachines,
              };
            });

            valuesToSet["segmentDetails"] = updatedSegmentDetails;
          } catch (e) {
            console.error("Failed to parse segmentDetails:", e);
          }
        } else {
          valuesToSet[field.label] = field.value;
        }
      }
    });
    reset({
      ...getValues(),
      ...valuesToSet,
    });
  }, [fieldData]);
  
  return (
    <div className="w-full h-full flex flex-col">
      <form
        className="w-full h-full flex flex-col"
        onSubmit={handleSubmit((data) => handleFormSubmit(data))}
      >
        <div className="w-full flex-auto basis-0 overflow-y-auto scrollbar-large">
          <div className="w-[93%] h-auto">
            <div className="w-full h-auto flex justify-between items-start pt-4">
              <div className={"w-["+inputContainerWidth+"%]"}>
                <div className="w-full h-auto">
                  <div className="w-full mb-[3.8rem]">
                    {(
                      isLoading ? (
                        <Skeleton width="100%" height={47} borderRadius={3} />
                      ) : (
                        <>
                          {fieldData.map((field: any, index: number) => {
                            const isHidden = index === 0;

                            const getInputField = (isColumnHide: any) => {
                              switch (field.type) {
                                case 1:
                                  return (
                                    <div style={{ display: isColumnHide === 1 ? "none" : "block" }}>
                                      <InputField
                                        labelName={field.headerName}
                                        type="text"
                                        id={field.label}
                                        isReadOnly={field.isEditRestrictable}
                                        isRequired={field.isMandatory === 1}
                                        formHandle={register(field.label)}
                                        error={(errors as any)[field.label]?.message}
                                      />
                                    </div>
                                  );
                                case 2:
                                  return (
                                    <div style={{ display: isColumnHide === 1 ? "none" : "block" }}>
                                      <SelectInput
                                        labelName={field.headerName}
                                        idName={field.label}
                                        name={field.label}
                                        control={control}
                                        isRequired={true}
                                        options={dependentOptions[field.headerName] || []}
                                        error={(errors as any)[field.label]?.message}
                                      />
                                    </div>
                                  );
                                case 3:
                                  return (
                                    <InputField
                                      labelName={field.headerName}
                                      type="datetime-local"
                                      id={field.label}
                                      isRequired={field.isMandatory === 1}
                                      formHandle={register(field.label)}
                                      error={(errors as any)[field.label]?.message}
                                    />
                                  );
                                case 4:
                                  return (
                                    <MultiSelectInput
                                      labelName={field.headerName}
                                      idName={field.label}
                                      isMulti={true}
                                      name={field.label}
                                      control={control}
                                      error={""}
                                      isSearchable={false}
                                      options={dependentOptions[field.headerName] || []}
                                      getOptionLabel={(option: any) => option.value}
                                      getOptionValue={(option: any) => option.id}
                                      isRequired={true}
                                    />
                                  );
                                case 5:
                                  if (!formData.imageUrl && field.value) {
                                    setFormData((prev: any) => ({
                                      ...prev,
                                      imageUrl: field.value,
                                    }));
                                  }
                                  setValue(field.label, formData.imageUrl);
                                  return (
                                    <UploadImage
                                      formData={formData}
                                      setFormData={setFormData}
                                      isImageLoader={isImageLoader}
                                      setImageLoader={setImageLoader}
                                    />
                                  );
                                case 6:
                                  if (!formData.imageUrl && field.value) {
                                    setFormData((prev: any) => ({
                                      ...prev,
                                      imageUrl: field.value,
                                    }));
                                  }
                                  setValue(field.label, formData.imageUrl || "");
                                  return (
                                    <UploadExcelFile
                                      formData={formData}
                                      handleSetFormData={handleSetFormData}
                                      isImageLoader={isImageLoader}
                                      setImageLoader={setImageLoader}
                                      field={field}
                                      error={(errors as any)[field.label]?.message}
                                    />
                                  );
                                case 7:
                                  const segmentDetailsHeader = headerDetails.find(
                                    (item: any) => item.headerName === "Segment Details"
                                  );
                                  return (
                                    <div>
                                      <SegmentFields
                                        control={control}
                                        register={register}
                                        errors={errors}
                                        headerDetails={segmentDetailsHeader}
                                      />
                                    </div>
                                  )
                                default:
                                  return null;
                              }
                            };

                            return (
                              <div
                                key={field.label}
                                style={{
                                  marginBottom: "20px",
                                  display: isHidden ? "none" : "block",
                                }}
                              >
                                {getInputField(field.isColumnHide)}
                              </div>
                            );
                          })}
                        </>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalPageFooter
          footerType="form"
          handleCancel={() => handleFormCancel()}
          isLoading={isLoading}
        />
      </form>
    </div>
  );
}
export default CreateUserMasterForm;
